import $ from 'jquery';
import customVideo from "./custom-video";
import getScrollWidth from "./scrollWidth";

export default function () {

    $('[data-custom-video-modal]').on('click', function (e) {
        e.preventDefault();
        const content = $('<div class="custom-video-modal__content"></div>'),
            overlay = $('<div class="custom-video-modal__overlay"></div>'),
            close = $('<div class="custom-video-modal__close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"></path></svg></div>'),
            modal = $('<div class="custom-video-modal"></div>').css('opacity', 0).append(overlay).append(close).append(content),
            videoType = $(this).data('custom-video-type') ?? 'youtube',
            videoUrl = $(this).data('custom-video-modal');

        $('body').append(modal).addClass('noscroll').css('margin-right', getScrollWidth());

        const video = $(`<video autoplay class="video-js custom-video" data-setup='{"fluid": true, "controlBar": {"pictureInPictureToggle": false}}' data-custom-video-type="${videoType}" data-custom-video-src="${videoUrl}"></video>`);
        content.append(video);
        const player = customVideo(video.get(0));

        $(modal).add(close).on('click', function (e) {
            if (e.target === this || $(e.target).closest('.custom-video-modal__content').length === 0) {
                $(modal).trigger('close');
            }
        });

        setTimeout(() => {
            $(modal).css('opacity', 1);
        }, 0);

        $(modal).on('close', function () {
            player.dispose();
            $(player).off();
            $(modal).off().children().off();
            $(modal).css('opacity', 0);
            $('body').removeClass('noscroll').css('margin-right', 0);
            setTimeout(() => {
                $(modal).remove();
            }, 300);
        });
    });
}